module.exports = __webpack_public_path__ + "img/zoom_out_map.cdea3dc5.svg";